import React from "react";

const InfPosts = () => {
  return (
    <>
      <div className="tab-content-section">
        <div className="row mt-3">
          <h4 className="mb-3">Top Posts</h4>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">August 8, 2025 5:59 AM</p>
                <p className="mb-0">NSDL up 60% from its IPO price...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">April 14, 2024 12:46 PM</p>
                <p className="mb-0">How I got NISM Certification...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">October 2, 2025</p>
                <p className="mb-0">IPO insights and analysis...</p>
              </div>
            </a>
          </div>
        </div>

        <div className="row mt-4">
          <h4 className="mb-3">Sponsored Posts</h4>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <span className="badge bg-danger mb-2">Sponsored</span>
                <p className="mb-0">Brand collaboration content example...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <span className="badge bg-danger mb-2">Sponsored</span>
                <p className="mb-0">Another sponsored campaign...</p>
              </div>
            </a>
          </div>
        </div>

        <div className="row mt-4">
          <h4 className="mb-3">Recent Posts</h4>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 12, 2026</p>
                <p className="mb-0">Recent market update post...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 11, 2026</p>
                <p className="mb-0">Blinkit delivery rider story...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="https://i.pinimg.com/736x/0b/78/9d/0b789d4c702d9d97d8dace7c66c9312d.jpg"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 10, 2026</p>
                <p className="mb-0">IPO breakdown and analysis...</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfPosts;
